<section class="m-section">
  <!-- <div class="container"> -->
  @if (!loader && blogEntries.length > 0) {
  <div class="hero-container">
    <div class="hero-banner" >
      <div class="banner-content banner-centered">
        <div class="text-content">
          <h1 class="hero-title">
            Nuestro <span class="text-highlight"> Blog</span>
          </h1>
          <!-- <p class="hero-description">
                Guías, casos de éxito y consejos prácticos sobre costos, materiales sostenibles, permisos y eficiencia energética para planificar y ejecutar proyectos confiables en CDMX y todo México.
              </p> -->
          <p class="hero-description">
            Explora ideas, tendencias y mejores prácticas en construcción en México: salud, industria, sector público y
            vivienda
          </p>
        </div>
        <!-- <div class="divider"></div> -->
        <div class="badges-section">
          <span class="badge-title">Explorar temas</span>
          <div class="badges badges-minimal">
            @for (topic of blogTopics; track topic.label) {
            <span class="badge badge-outline">
              <lucide-icon [name]="topic.icon" size="16"></lucide-icon>
              <span class="badge-label">{{ topic.label }}</span>
            </span>
            }
          </div>
        </div>
      </div>
    </div>
    <main class="blogs">

      <article class="card-featured">
        <div class="all" data-aos="fade-right" data-aos-delay="100" data-aos-duration="1000">
          <div class="image" (click)="goToPost(cardFeatured._id, cardFeatured.blogTitle)">
            <img [ngSrc]="getImageSrc(cardFeatured)" [alt]="cardFeatured.blogTitle" fill priority />
          </div>

          <div class="info-card">
            <p class="text date">{{ cardFeatured.date }}</p>
            <h2>{{ getContent(cardFeatured.blogTitle, 70) }}</h2>
            <div class="blog-content" [innerHTML]="getContent(cardFeatured.blogContent, 100)">
            </div>

            <button class="read-more-btn" (click)="goToPost(cardFeatured._id, cardFeatured.blogTitle)">
              <span>Ver más</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </button>
          </div>
        </div>

        <header class="subtitle" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
          <h3>Explora más artículos pensados para tus proyectos</h3>
        </header>
      </article>

      @if (blogEntries.length > 0) {

      <section class="list-blogs">

        <article
          *ngFor="let item of blogEntries | paginate: { itemsPerPage: 6, currentPage: currentPage, totalItems: blogEntries.length }; let $index = index"
          class="card-blog" [ngClass]="{'grid': styleCards, 'animation': animation}">

          <div class="card">
            <div class="all" data-aos="fade-right" data-aos-delay="100" data-aos-duration="1000">

              <div class="image" (click)="goToPost(item._id, item.blogTitle)">
                <i class="pi pi-arrow-up-right arrow-up" [ngClass]="{
                       'arrow-white': $index % 3 === 0,
                       'arrow-red': $index % 3 === 1,
                       'arrow-green': $index % 3 === 2
                     }">
                </i>

                <img [ngSrc]="getImageSrc(item)" [alt]="item.blogTitle" fill />
              </div>

              <div class="info-card">
                <p class="text date">{{ item.date }}</p>
                <h2>{{ getContent(item.blogTitle, 70) }}</h2>
                <div class="blog-content" [innerHTML]="getContent(item.blogContent, 100)">
                </div>
              </div>

            </div>
          </div>

        </article>

      </section>

      <nav class="pagination" aria-label="Paginación del blog">
        <pagination-controls (pageChange)="onPageChange($event); goTo('nav')" previousLabel="" nextLabel="">
        </pagination-controls>
      </nav>

      }

    </main>
  </div>
  } @else {
  <app-loader></app-loader>
  }

  <!-- </div> -->
</section>